import { Form, FormElement, FormElementResponse, FormElementTag, FormResponse } from '@/models/Form';
import { Report } from '@/models/Report';
import Vue from 'vue';
import { IVuexStore } from '.';

export const mutations = {
    addError: (state: IVuexStore, error: string) => {
        if (!state.errors.includes(error)) {
            state.errors.push(error);
        }
    },
    removeError: (state: IVuexStore, error: string) => {
        const index = state.errors.indexOf(error);
        state.errors.splice(index - 1, 1);
    },
    clearErrors: (state: IVuexStore) => {
        state.errors = [];
    },
    setLoading: (state: IVuexStore, loadingState: boolean) => {
        state.loading = loadingState;
    },
    setForm(state: IVuexStore, data: FormResponse) {
        state.form = new Form(data);
        state.updated = state.form.updated;
    },
    addElement: (state: IVuexStore, data: FormElementResponse) => {
        const element = new FormElement(data);

        if (!state.elements.includes(element)) {
            state.elements.push(element);

            if (element.tags) {
                element.tags.forEach((tag: FormElementTag) => {
                    Vue.set(state.tags, tag.id, tag);
                });
            }
        }
    },
    prev: (state: IVuexStore, current: FormElement) => {
        const index = state.elements.indexOf(current);
        const id = state.elements[index].id;

        Vue.delete(state.answers, id);
        state.elements.splice(index, 1);
    },
    restart: (state: IVuexStore) => {
        const id = state.form && state.form.id;
        localStorage[`rbb:client:${id}:${state.accessCode}`] = JSON.stringify(null);
        state.form = null;
        state.report = null;
        state.errors = [];
        state.elements = [];
        state.answers = {};
    },
    addAnswer: (state: IVuexStore, { elementId, answer }: { elementId: number; answer: any }) => {
        Vue.set(state.answers, elementId, answer);
    },
    setReport: (state: IVuexStore, data: any) => {
        state.report = new Report(data);
    },
    setAccessCode: (state: IVuexStore, accessCode: string) => {
        state.accessCode = accessCode;
    },
    initStorage: (state: IVuexStore, { formId, accessCode }: { formId: number; accessCode: string }) => {
        const storageItems = localStorage[`rbb:client:${formId}:${accessCode}`];

        if (storageItems) {
            const items = JSON.parse(storageItems);

            for (const key in items) {
                if (items[key]) {
                    (state as any)[key] = items[key];
                }
            }
        }
    },
};
